//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import Button from '@components/atoms/button/Button';
import { DefaultButtonStyles } from '@components/atoms/button/buttonStyles';
import { BodyBoldText } from '@components/atoms/text/Text';
import { Select } from '@components/primitives/select/Select';
import { UIATrackingIds } from '@uia/constants/uiaConstants';
import { parseHashtags } from '@utils/stringUtils';

const MIN_HASHTAGS_LENGTH = 2;

export interface RightsHashtagSelectorProps {
  isDisabled: boolean;
  onChange: (hashtag: string) => void;
  rightsRequestText: string | undefined;
  value: string | undefined;
}

export const RightsHashtagSelector = ({
  isDisabled,
  onChange,
  rightsRequestText = '',
  value,
}: RightsHashtagSelectorProps) => {
  const hashtags = parseHashtags(rightsRequestText);
  if (hashtags.length < MIN_HASHTAGS_LENGTH) {
    return <></>;
  }

  return (
    <Wrapper>
      <BodyBoldText>Approval Hashtag</BodyBoldText>
      <Select disabled={isDisabled} onValueChange={onChange} value={value}>
        <Select.Trigger asChild>
          <Button
            buttonStyles={DefaultButtonStyles}
            isDisabled={isDisabled}
            isDropdown={true}
            trackingId={UIATrackingIds.RIGHTS_REQUEST_HASHTAG_SELECT}
          >
            <Select.Value placeholder='Select value' />
          </Button>
        </Select.Trigger>
        <SelectContent align='start'>
          {hashtags.map((hashtag) => (
            <Select.Item key={hashtag} value={hashtag}>
              <Select.ItemText>{hashtag}</Select.ItemText>
              <Select.Indicator />
            </Select.Item>
          ))}
        </SelectContent>
      </Select>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectContent = styled(Select.Content)(
  ({ theme }) => `
    z-index: ${theme.zindex.modal};
  `,
);
